// export const
import { Button } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import {
  color, desktopVW, linkRg, minTablet, mobileVW, maxTablet,
} from '../styles';

export const InputField = ({
  ref, onBlur, onChange, onFocus, onClick, value, title, type,
} : any) => (
  <StyledInput type={type} ref={ref} onClick={onClick} placeholder={title} value={value} onBlur={onBlur} onChange={onChange} onFocus={onFocus} />
);

export const OptionField = ({ title, items, onChange } : { title : string, items : any, onChange : any}) => (
  <StyledOption onChange={onChange}>
    <option value="" disabled selected>{title}</option>
    {items && items.map((item : ({title: string})) => (
      <option>{item.title}</option>
    ))}
  </StyledOption>
);

export const ListItem = ({
  title, price, onClick, quantity, onClickMinus,
} : any) => (
  <StyledListItem>
    <StyledColumn>
      {title}
    </StyledColumn>
    <StyledColumn>
      <StyledPrice>
        {price}
      </StyledPrice>
      <StyledInfo xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
        {/* <g transform="translate(-1209 -2410)">
          <circle cx="11.5" cy="11.5" r="11.5" transform="translate(1214 2415)" />
          <path d="M1225.5 2410a16.5 16.5 0 1016.5 16.5 16.5 16.5 0 00-16.5-16.5zm-1.907 23.622v-7.553a1.907 1.907 0 013.813 0v7.553a1.907 1.907 0 01-3.813 0zm1.907-11.54a2.292 2.292 0 112.292-2.292 2.292 2.292 0 01-2.292 2.292z" fill="#f3f3f3" />
        </g> */}
      </StyledInfo>
      <StyledButton>
        <StyledIcon onClick={() => onClick()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
          <g transform="translate(-784 -2633)">
            {/* <circle fill="#F3F3F3" cx="16.5" cy="16.5" r="16.5" transform="translate(784 2633)" /> */}
            <path fill="none" stroke="#000" strokeLinecap="round" strokeWidth="3" d="M800.5 2643.838v10.324M805.662 2649h-10.324" />
          </g>
        </StyledIcon>
      </StyledButton>
      <StyledCounter>
        {quantity}
      </StyledCounter>
      <StyledButton>
        <StyledIcon onClick={() => quantity > 0 && onClickMinus()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33">
          <g transform="translate(-801 -2381)">
            {/* <circle cx="16.5" cy="16.5" r="16.5" transform="translate(801 2381)" fill="#f3f3f3" /> */}
            <path fill="none" stroke="#000" strokeLinecap="round" strokeWidth="3" d="M822.662 2397.5h-10.324" />
          </g>
        </StyledIcon>
      </StyledButton>
    </StyledColumn>
  </StyledListItem>
);

const StyledInput = styled.input`
  width: 100%;;
  padding: ${mobileVW(14)} ${mobileVW(30)};
  border-radius: ${mobileVW(17)};
  border: 1px solid #70707050;
  ${linkRg};
  transition: all .35s cubic-bezier(0.46, 0, 0.31, 1);

  ${maxTablet} {
    & + & {
      margin-top: ${mobileVW(30)};
    }
  }

  ${minTablet} {
    width: ${desktopVW(375)};
    padding: ${desktopVW(14)} ${desktopVW(30)};
    border-radius: ${desktopVW(17)};

    & + & {
      margin-left: ${desktopVW(30)};
    }
  }


  &::placeholder {
    color: ${color.black}
  }
`;

const StyledOption = styled.select`
  width: 100%;
  padding: ${mobileVW(14)} ${mobileVW(30)};
  border-radius: ${mobileVW(17)};
  border: 1px solid #70707050;
  background: ${color.white};
  ${linkRg};
  transition: all .35s cubic-bezier(0.46, 0, 0.31, 1);

  /* &:active {
    border: 1px solid ${color.green};
  }

  &:focus {
    border: 1px solid ${color.green};
  } */

  & + & {
    margin-left: ${desktopVW(30)};
  }

  ${minTablet} {
    width: ${desktopVW(375)};
    padding: ${desktopVW(14)} ${desktopVW(30)};
    border-radius: ${desktopVW(17)};

      & + & {
      margin-left: ${mobileVW(30)};
    }
  }



  &::placeholder {
    color: ${color.black};
  }
`;

const StyledButton = styled(Button)`
  padding: 0 !important;
  background: ${color.greyLight} !important;
  color: ${color.black} !important;
  min-width: inherit !important;
  border-radius: 50% !important;
`;

const StyledListItem = styled.li`
  width: 100%;
  padding: ${mobileVW(8)} ${mobileVW(30)};
  border-radius: ${mobileVW(17)};
  border: 1px solid #70707050;
  display: flex;
  transition: all .45s cubic-bezier(0.46, 0, 0.31, 1) !important;

  /* &:hover {
    background: ${color.green};s
    color: ${color.white};
  } */

  flex-direction: column;
  ${linkRg}

  & + & {
    margin-top: ${mobileVW(15)};
  }

  &::placeholder {
    color: ${color.black}
  }

  ${minTablet} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: ${desktopVW(8)} ${desktopVW(30)};
    border-radius: ${desktopVW(17)};
  
    & + & {
      margin-top: ${desktopVW(15)};
    }
  }
`;

const StyledColumn = styled.div`
  display: flex;
  align-items: center;
`;

const StyledInfo = styled.svg`
  width: ${mobileVW(33)};
  height: ${mobileVW(33)};
  margin-right: ${mobileVW(12)};

  ${minTablet} {
    width: ${desktopVW(33)};
    height: ${desktopVW(33)};
    margin-right: ${desktopVW(12)};
  }
`;

const StyledIcon = styled.svg`
  width: ${mobileVW(33)};
  height: ${mobileVW(33)};

  ${minTablet} {
    width: ${desktopVW(33)};
    height: ${desktopVW(33)};
  }
`;

const StyledCounter = styled.p`
  border-radius: 50%;
  background: ${color.greyLight};
  width: ${mobileVW(33)};
  height: ${mobileVW(33)};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 ${mobileVW(5)};
  color: ${color.black};

  ${minTablet} {
    width: ${desktopVW(33)};
    height: ${desktopVW(33)};
    margin: 0 ${desktopVW(5)};
  }
`;

const StyledPrice = styled.p`
  margin-right: 0;

  ${minTablet} {
    margin-right: ${desktopVW(30)};
  }
`;
